/**
 * @flow
 * @relayHash 39017410ed5c32d6f3d54a3325215ec6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ReportList_viewer$ref = any;
export type ReportListQueryVariables = {|
  clientAccountId?: ?string,
  first?: ?number,
  offset?: ?number,
  triggerIn?: ?$ReadOnlyArray<?string>,
  reportTypeIn?: ?$ReadOnlyArray<?string>,
|};
export type ReportListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: ReportList_viewer$ref
  |}
|};
export type ReportListQuery = {|
  variables: ReportListQueryVariables,
  response: ReportListQueryResponse,
|};
*/


/*
query ReportListQuery(
  $clientAccountId: ID
  $first: Int
  $offset: Int
  $triggerIn: [String]
  $reportTypeIn: [String]
) {
  viewer {
    ...ReportList_viewer_4mbSHB
    id
  }
}

fragment ReportList_viewer_4mbSHB on Query {
  reports(first: $first, offset: $offset, clientAccountId: $clientAccountId, orderBy: "-createdAt", triggerIn: $triggerIn, reportTypeIn: $reportTypeIn) {
    edges {
      node {
        id
        createdAt
        updatedAt
        pdfUrl
        xlsxUrl
        reportType
        trigger
        state
        pdf
        xlsx
        clientAccount {
          id
          name
          accountPtr {
            id
            name
          }
        }
        documentreport {
          documentFile
          documentFileUrl
          id
        }
        customreport {
          name
          year
          id
        }
      }
    }
    count
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "clientAccountId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "triggerIn",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "reportTypeIn",
    "type": "[String]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "clientAccountId",
  "variableName": "clientAccountId"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v4 = {
  "kind": "Variable",
  "name": "reportTypeIn",
  "variableName": "reportTypeIn"
},
v5 = {
  "kind": "Variable",
  "name": "triggerIn",
  "variableName": "triggerIn"
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ReportListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ReportList_viewer",
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ReportListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "reports",
            "storageKey": null,
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "-createdAt"
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "concreteType": "ReportNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ReportNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ReportNode",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "updatedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "pdfUrl",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "xlsxUrl",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "reportType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "trigger",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "state",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "pdf",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "xlsx",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "clientAccount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ClientAccountNode",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "accountPtr",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AccountNode",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "documentreport",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentReportNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "documentFile",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "documentFileUrl",
                            "args": null,
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "customreport",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CustomReportNode",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "year",
                            "args": null,
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ReportListQuery",
    "id": null,
    "text": "query ReportListQuery(\n  $clientAccountId: ID\n  $first: Int\n  $offset: Int\n  $triggerIn: [String]\n  $reportTypeIn: [String]\n) {\n  viewer {\n    ...ReportList_viewer_4mbSHB\n    id\n  }\n}\n\nfragment ReportList_viewer_4mbSHB on Query {\n  reports(first: $first, offset: $offset, clientAccountId: $clientAccountId, orderBy: \"-createdAt\", triggerIn: $triggerIn, reportTypeIn: $reportTypeIn) {\n    edges {\n      node {\n        id\n        createdAt\n        updatedAt\n        pdfUrl\n        xlsxUrl\n        reportType\n        trigger\n        state\n        pdf\n        xlsx\n        clientAccount {\n          id\n          name\n          accountPtr {\n            id\n            name\n          }\n        }\n        documentreport {\n          documentFile\n          documentFileUrl\n          id\n        }\n        customreport {\n          name\n          year\n          id\n        }\n      }\n    }\n    count\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'be2b5122f5ab615243788209553ed633';
module.exports = node;
